// HortiClub video-review carousel — two independent behaviors on the same
// section: (1) prev/next arrow scrolling, mirroring the exact pattern
// already established in hortclub-product-teaser.js, and (2) per-card
// video hover-to-play (desktop) / tap-to-play (touch) with an unmute
// toggle, replicating planttherapy.com's review-video cards.
//
// Round 3 (2026-08): updateArrows() now also drives the mobile-only
// scroll-progress bar (sections/hortclub-video-reviews.liquid's
// [data-carousel-progress-fill]) — reusing the exact same scroll listener
// that already tracked arrow disabled-state, rather than adding a second
// scroll listener on the same track.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;

  document.querySelectorAll('.hortclub-video-reviews [data-carousel]').forEach(function (carousel) {
    if (carousel.dataset.carouselInit) return;
    carousel.dataset.carouselInit = 'true';

    var track = carousel.querySelector('[data-carousel-track]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var progressFill = carousel.querySelector('[data-carousel-progress-fill]');

    if (track && prevBtn && nextBtn) {
      var getScrollAmount = function () {
        var firstItem = track.querySelector('li');
        if (!firstItem) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.gap || styles.columnGap || '18') || 18;
        return firstItem.getBoundingClientRect().width + gap;
      };

      var updateArrows = function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll;

        if (progressFill) {
          var pct = maxScroll <= 0 ? 100 : Math.min(100, Math.max(0, (track.scrollLeft / maxScroll) * 100));
          // Minimum width keeps the fill visible as a "here's where you
          // are" marker even at scrollLeft 0, instead of collapsing to a
          // sliver against the track's own rounded end.
          progressFill.style.width = Math.max(pct, 12) + '%';
        }
      };

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      });

     var scrollRaf = null;

track.addEventListener(
  'scroll',
  function () {
    if (scrollRaf) return;

    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = null;
      updateArrows();
    });
  },
  { passive: true }
);

      // Shared, page-lifetime resize dispatcher instead of one window-level
      // listener per carousel instance — see the identical comment in
      // hortclub-product-teaser.js for why a plain per-carousel listener
      // leaks a reference to detached DOM on every Theme Editor section
      // reload. Entries whose track element is no longer in the document
      // get pruned on the next resize.
      window.hortclubVideoReviewsCarousels = window.hortclubVideoReviewsCarousels || [];
      window.hortclubVideoReviewsCarousels.push({ track: track, updateArrows: updateArrows });
      updateArrows();
    }

    if (!window.hortclubVideoReviewsResizeInit) {
      window.hortclubVideoReviewsResizeInit = true;
      window.addEventListener('resize', function () {
        window.hortclubVideoReviewsCarousels = (window.hortclubVideoReviewsCarousels || []).filter(function (entry) {
          if (!document.body.contains(entry.track)) return false;
          entry.updateArrows();
          return true;
        });
      });
    }

    carousel.querySelectorAll('[data-video-card]').forEach(function (card) {
      var video = card.querySelector('video');
      var muteBtn = card.querySelector('[data-video-mute]');
      if (!video) return;

      video.muted = true;

      var play = function () {
        if (prefersReducedMotion) return;
        video.play().catch(function () {});
      };

      var pause = function () {
        video.pause();
      };

      if (canHover) {
        card.addEventListener('mouseenter', play);
        card.addEventListener('mouseleave', pause);
        card.addEventListener('focusin', play);
        card.addEventListener('focusout', pause);
      } else {
        card.addEventListener('click', function (event) {
          if (event.target.closest('[data-video-mute]')) return;
          if (video.paused) {
            play();
          } else {
            pause();
          }
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          video.muted = !video.muted;
          muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        });
      }
    });
  });
})();